module.exports = __webpack_public_path__ + "img/logo.a24afb33.png";